function e(e,r){return e.reduce(((e,t)=>{const n=t[r];return{...e,[`${n}`]:t}}),{})}export{e as default};
